import { render, staticRenderFns } from "./loginElement.vue?vue&type=template&id=0206b89a&scoped=true"
import script from "./loginElement.vue?vue&type=script&lang=js"
export * from "./loginElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206b89a",
  null
  
)

export default component.exports